import React, { useContext } from "react";
import { Link as ScrollLink } from "react-scroll";
import { themeContext } from "../../../Context";
import "./ErpModules.css";

const modules = [
  {
    title: "الحسابات",
    desc: "قيود يومية، دليل حسابات، وتقارير مالية تساعد على ضبط الدورة المحاسبية.",
  },
  {
    title: "المبيعات والفواتير",
    desc: "عروض أسعار، فواتير مبيعات، ومتابعة التحصيل من واجهة واحدة.",
  },
  {
    title: "المشتريات",
    desc: "أوامر شراء، فواتير موردين، ومتابعة الالتزامات والموردين.",
  },
  {
    title: "المخزون",
    desc: "مستودعات متعددة، حركة أصناف، وتنبيهات تساعد على تقليل الفاقد.",
  },
  {
    title: "التقارير",
    desc: "لوحات وتقارير تشغيلية ومالية لدعم القرار بسرعة.",
  },
  {
    title: "الأمان والصلاحيات",
    desc: "تحكم دقيق بصلاحيات المستخدمين وحماية بيانات المنشأة.",
  },
  {
    title: "أنظمة قطاعية متخصصة",
    desc: "فنادق واستراحات، مطاعم، خياطة، محطات، طبية، إنتاج، نقل، لوجستيات، وغيرها من الأنظمة القطاعية.",
  },
];

const ErpModules = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="erp-modules" id="erp-modules">
      <div className="erp-section-head">
        <h2 style={{ color: darkMode ? "white" : undefined }}>
          وحدات نظام ERP وبرنامج المحاسبة
        </h2>
        <p>
          من الحسابات والمبيعات إلى المخزون والتقارير — دورة عمل مكتملة في منصة واحدة.
        </p>
      </div>
      <div className="erp-modules-grid">
        {modules.map((mod) => (
          <article className="erp-module-card" key={mod.title}>
            <h3 style={{ color: darkMode ? "white" : undefined }}>{mod.title}</h3>
            <p>{mod.desc}</p>
            <ScrollLink
              to="contact"
              spy={true}
              smooth={true}
              offset={-40}
              className="erp-card-cta"
            >
              اطلب عرضاً
            </ScrollLink>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ErpModules;
